import {
  enumCatalogEntityType,
  enumCatalogShareStatus,
  type CatalogShareResourceListResponseBffApi,
  type CatalogShareResourceReadApi,
  type CatalogShareResourceReadBffApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import { faker } from '@faker-js/faker';
import { generateInitialPaginationApi } from '@ingenico/api-sdk-core/mocks';
import { HttpResponse } from 'msw';

const FIRST_NAMES = ['Alice', 'Bob', 'Charlie', 'Diana', 'Ethan', 'Fiona', 'George', 'Hannah', 'Ivan', 'Julia'];
const LAST_NAMES = ['Smith', 'Jones', 'Brown', 'Taylor', 'Wilson', 'Davies', 'Evans', 'Thomas', 'Roberts', 'Walker'];
const APP_NAMES = ['Payments App', 'Loyalty App', 'Receipts App', 'Refunds App', 'Inventory App'];

function generateSafeEmail(): string {
  const local = faker.string.alpha({ length: { min: 5, max: 10 }, casing: 'lower' });
  const domain = faker.helpers.arrayElement(['example.com', 'mail.com', 'inbox.com']);
  return `${local}@${domain}`;
}

function generateRecipients(): CatalogShareResourceReadBffApi['recipients'] {
  const count = faker.number.int({ min: 1, max: 20 });
  return faker.helpers.multiple(
    () => {
      const email = generateSafeEmail();
      return { email, normalizedEmail: email };
    },
    { count },
  );
}

function generateCatalogShare(): CatalogShareResourceReadBffApi {
  const status = faker.helpers.arrayElement(Object.values(enumCatalogShareStatus));
  const createdAt = faker.date.recent({ days: 30 });
  const name = `${faker.helpers.arrayElement(FIRST_NAMES)} ${faker.helpers.arrayElement(LAST_NAMES)}`;
  return {
    id: faker.string.uuid(),
    createdAt,
    createdBy: { id: faker.string.uuid(), name },
    emailRetentionExpirationDate: faker.date.future({ years: 1, refDate: createdAt }),
    maxUsageCount: faker.number.int({ min: 1, max: 5 }),
    recipients: generateRecipients(),
    status,
    statusMetadata: { type: status },
    target: {
      id: faker.string.uuid(),
      type: enumCatalogEntityType.APPLICATION_VERSION,
      versionMetadata: {
        parentName: faker.helpers.arrayElement(APP_NAMES),
        versionNumber: faker.system.semver(),
      },
    },
  };
}

export function searchCatalogSharesBffV2CustomHandler() {
  const count = faker.number.int({ min: 3, max: 20 });
  const payload: CatalogShareResourceListResponseBffApi = {
    pagination: generateInitialPaginationApi(count),
    data: faker.helpers.multiple(() => generateCatalogShare(), { count }),
  };
  return HttpResponse.json(payload);
}

export function createCatalogShareV2CustomHandler() {
  const createdAt = new Date();
  const payload: CatalogShareResourceReadApi = {
    id: faker.string.uuid(),
    createdAt,
    createdBy: faker.string.uuid(),
    emailRetentionExpirationDate: faker.date.future({ years: 1, refDate: createdAt }),
    maxUsageCount: 1,
    recipients: generateRecipients(),
    status: enumCatalogShareStatus.PENDING,
    statusMetadata: { type: enumCatalogShareStatus.PENDING },
    target: {
      id: faker.string.uuid(),
      type: enumCatalogEntityType.APPLICATION_VERSION,
      versionMetadata: {
        parentName: faker.helpers.arrayElement(APP_NAMES),
        versionNumber: faker.system.semver(),
      },
    },
  };
  return HttpResponse.json(payload, { status: 202 });
}
